// Forwards clicks on .product-card__quick-view to the hidden quick-add-component
// inside the same product-card. For variant products, opens the quick-add modal
// by directly invoking the component's handleClick method (the synthetic-click
// path doesn't trigger the theme's on:click delegation). For single-SKU products,
// clicks the inner Add button so it adds straight to cart.
if (window.__quickViewTriggerInit) {
  // already wired; skip duplicate listeners
} else {
  window.__quickViewTriggerInit = true;
document.addEventListener('click', function (event) {
  const trigger = event.target.closest('.product-card__quick-view');
  if (!trigger) return;
  event.preventDefault();
  event.stopPropagation();

  const card = trigger.closest('product-card') || trigger.closest('.product-card');
  if (!card) return;

  const qaComponent = card.querySelector('quick-add-component');
  if (!qaComponent) return;

  const isSingleSku = qaComponent.dataset.quickAddButton === 'add';

  if (isSingleSku) {
    const addBtn = qaComponent.querySelector('.quick-add__button--add');
    if (addBtn) {
      addBtn.click();
      return;
    }
  }

  // Variant product (or fallback): open the quick-add modal directly
  if (typeof qaComponent.handleClick === 'function') {
    try {
      qaComponent.handleClick(new Event('click'));
      return;
    } catch (e) {
      // fall through to inner-click fallback
    }
  }

  const chooseBtn = qaComponent.querySelector(
    '.quick-add__button--choose, .quick-add__button--add'
  );
  if (chooseBtn) chooseBtn.click();
});
}
